import { render, staticRenderFns } from "./studelay.vue?vue&type=template&id=7c2e14f9&scoped=true"
import script from "./studelay.vue?vue&type=script&lang=js"
export * from "./studelay.vue?vue&type=script&lang=js"
import style0 from "./studelay.vue?vue&type=style&index=0&id=7c2e14f9&prod&scoped=scoped&lang=css"
import style1 from "./studelay.vue?vue&type=style&index=1&id=7c2e14f9&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2e14f9",
  null
  
)

export default component.exports